<div class="ice-detail-container" *ngIf="selectedAction">
  <ul
    ngbNav
    #detailNav="ngbNav"
    [(activeId)]="activeDetailTab"
    class="nav-tabs"
  >
    <li [ngbNavItem]="1">
      <a class="details-nav-item" ngbNavLink>Details</a>
      <ng-template ngbNavContent>
        <div class="ice-detail-table">
          <table>
            <tbody>
              <!-- Event-level rows: value cell spans option columns in options mode -->
              <tr
                *ngFor="let row of detail.eventLevelRows"
                data-testid="detail-row"
              >
                <td class="detail-label">{{ row.property }}</td>
                <td
                  class="detail-value"
                  [attr.colspan]="
                    detail.mode === 'options'
                      ? optionsMatrix.groups.length
                      : null
                  "
                >
                  {{ row.value }}
                </td>
              </tr>

              <!-- Options mode: section header, column headers, per-label rows -->
              <ng-container *ngIf="detail.mode === 'options'">
                <!-- Section header spanning all columns -->
                <tr
                  class="election-options-header"
                  data-testid="election-options-header"
                >
                  <td [attr.colspan]="optionsMatrix.groups.length + 1">
                    {{ detail.sectionHeader }}
                  </td>
                </tr>

                <!-- Column header row: blank label cell + one <th> per option -->
                <tr
                  class="election-options-column-header"
                  data-testid="election-options-column-header"
                >
                  <td></td>
                  <th *ngFor="let group of optionsMatrix.groups" scope="col">
                    Option {{ group.optionNumber }}
                  </th>
                </tr>

                <!-- One row per distinct field-label across all options -->
                <tr
                  *ngFor="let label of optionsMatrix.labels"
                  class="election-option-field-row"
                  data-testid="election-option-row"
                >
                  <td class="detail-label">{{ label }}</td>
                  <td
                    *ngFor="let group of optionsMatrix.groups"
                    class="detail-value"
                    [class.election-option-cell-muted]="
                      valueFor(label, group) === '—'
                    "
                    [attr.data-option-number]="group.optionNumber"
                    data-testid="election-option-cell"
                  >
                    {{ valueFor(label, group) }}
                  </td>
                </tr>
              </ng-container>
            </tbody>
          </table>
        </div>
      </ng-template>
    </li>
    <li [ngbNavItem]="2">
      <a class="details-nav-item" ngbNavLink>Raw JSON</a>
      <ng-template ngbNavContent>
        <pre data-testid="ice-detail-json" class="ice-detail-json">{{
          formattedJson
        }}</pre>
      </ng-template>
    </li>
  </ul>
  <div class="detail-tab-content" [ngbNavOutlet]="detailNav"></div>
</div>
